import { apiFetch, type AjaxResult } from './http';

export type SearchQuota = {
  freeSearchRemaining?: number;
  dailyCombinedLimit?: number;
  dailyCombinedUsed?: number;
  dailyCombinedRemaining?: number;
  memberActive?: boolean;
  pointsBalance?: number;
  orderPointsCost?: number;
  searchPointsCost?: number;
  todayOrderUsed?: number;
  todaySearchUsed?: number;
  /** @deprecated 兼容旧接口 */
  dailyLimit?: number;
  usedToday?: number;
  remaining?: number;
};

export type SearchRecordResult = SearchQuota & {
  orderNo?: string;
  searchOrderId?: number;
  status?: string;
  responseJson?: string;
  consumeMode?: string;
  pointsCharged?: number;
  failureReason?: string;
};

export async function recordHomeSearch(keyword: string): Promise<AjaxResult<SearchRecordResult>> {
  return apiFetch<SearchRecordResult>('/api/app/search/record', {
    method: 'POST',
    body: JSON.stringify({ keyword }),
    auth: true,
  });
}

export async function fetchSearchQuota(): Promise<AjaxResult<SearchQuota>> {
  return apiFetch<SearchQuota>('/api/app/search/quota', { method: 'GET', auth: true });
}

export type SearchResultDetail = {
  searchOrderId?: number;
  orderNo?: string;
  keyword?: string;
  status?: string;
  responseJson?: string;
  pointsBalance?: number;
  failureReason?: string;
};

export async function fetchSearchResult(searchOrderId: number): Promise<AjaxResult<SearchResultDetail>> {
  return apiFetch<SearchResultDetail>(`/api/app/search/result/${searchOrderId}`, {
    method: 'GET',
    auth: true,
  });
}
